import React, { useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import DeductionInvoiceList from '../../../components/Reconciliation/DeductionInvoiceList/DeductionInvoiceList';
import Spinner from '../../../components/Tools/spinner';
import SubHeader from '../../../components/Subheader/Subheader';
import CustomBreadcrumbs from '../../../components/Tools/Breadcumbs';

const DeductionListing = ({ config }) => {
    const { financialYears } = useSelector((state) => state.authData);
    const fyList = financialYears.payload.fy_list;
    const fyIdRef = useRef(localStorage.getItem('globalDateId'));
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [searchStr, setSearchStr] = useState('');
    const [dateColumn, setDateColumn] = useState('voucher_date');
    const [loading, setLoading] = useState(false);
    const [, setSelectedInvoice] = useState([]);

    const handlePageTrigger = () => {
        fyIdRef.current = localStorage.getItem('globalDateId');
        setFromDate('');
        setToDate('');
        setSearchStr('');
        setDateColumn('voucher_date');
    };

    return (
        <div>
            {loading && <Spinner />}
            <SubHeader fy_list={fyList} handlePageTrigger={handlePageTrigger} />
            <div className="row" style={{ padding: '10px 16px' }}>
                <div className="col-md-6">
                    <h4 style={{ color: '#28326f', margin: 0 }}>{config.title}</h4>
                    <CustomBreadcrumbs linksArray={[]} title={config.title} />
                </div>
                <div className="col-md-6" />
            </div>
            <div className="scheme p-3">
                <DeductionInvoiceList
                    apiFlag={config.apiFlag}
                    amountField={config.amountField}
                    amountHeader={config.amountHeader}
                    fromDate={fromDate}
                    toDate={toDate}
                    searchStr={searchStr}
                    dateColumn={dateColumn}
                    setLoading={setLoading}
                    setSelectednvoice={setSelectedInvoice}
                />
            </div>
        </div>
    );
};

export default DeductionListing;
